import { ApiCallPost } from "../../Authentication/AuthAction/Apicall";

const API_BASE_URL = "https://dev.api.cryptoindia.in";

export const weburl = `${window.location.origin}/`;

export const ApiConfig = {
  baseUrl: `${API_BASE_URL}/`,
  baseType: `${API_BASE_URL}/v1/user/`,
  sendEmail: "send-email",
};

const AuthService = {

  sendUserEmail: async (signId) => {
    const url = ApiConfig.baseType + ApiConfig.sendEmail;

    const params = {
      email: signId?.toLowerCase()?.trim(),
      type: "launch"
    };

    const headers = {
      "Content-Type": "application/json",
    };

    return ApiCallPost(url, params, headers);
  },

};

export default AuthService;